module.exports = __webpack_public_path__ + "img/a16f7fe0ec730e3777874ca2f573f79c.a16f7fe0.png";